import { mxCellState } from 'mxgraph'
import mx from './factory'
import MyGraph from './graph'

class mxIcon {
  images: HTMLImageElement[]
  graph: MyGraph
  iconSize: string
  scale: number
  handle?: (type: string, evt: MouseEvent, cell: mxCellState) => void
  constructor(state: mxCellState) {
    this.images = []
    this.graph = state.view.graph as MyGraph
    this.scale = this.graph.view.scale
    this.iconSize = `${22 * this.scale}px`
    this.createRightIcon(state)
    this.createLeftIcon(state)
    this.createUpIcon(state)
    this.createDownIcon(state)
  }
  destroy() {
    this.images.forEach((ele) => {
      ele.parentNode?.removeChild(ele)
    })
  }
  createRightIcon(state: mxCellState) {
    const right = mx.mxUtils.createImage('images/triangle-right.png')
    right.setAttribute('title', '平级节点')
    right.style.position = 'absolute'
    right.style.cursor = 'pointer'
    right.style.width = this.iconSize
    right.style.height = this.iconSize
    right.style.left = state.x + (state.width + 6 * this.scale) + 'px'
    right.style.top = state.y + state.height / 2 - 10 * this.scale + 'px'

    state.view.graph.container.appendChild(right)
    this.images.push(right)
    right.addEventListener('click', (evt: any) => {
      this.handle && this.handle('right', evt, state)
    })
    // mx.mxEvent.addGestureListeners(
    //   right,
    //   mx.mxUtils.bind(this, (evt: any) => {
    //     this.handle && this.handle('right', evt, state)
    //   })
    // )
  }
  createLeftIcon(state: mxCellState) {
    const left = mx.mxUtils.createImage('images/triangle-left.png')
    left.setAttribute('title', '平级节点')
    left.style.position = 'absolute'
    left.style.cursor = 'pointer'
    left.style.width = this.iconSize
    left.style.height = this.iconSize
    left.style.left = state.x - 28 * this.scale + 'px'
    left.style.top = state.y + state.height / 2 - 10 * this.scale + 'px'

    state.view.graph.container.appendChild(left)
    this.images.push(left)
    mx.mxEvent.addGestureListeners(left, (evt: any) => {
      if (this.handle) {
        this.handle('left', evt, state)
      }
    })
  }
  createUpIcon(state: mxCellState) {
    const up = mx.mxUtils.createImage('images/triangle-up.png')
    up.setAttribute('title', '平级节点')
    up.style.position = 'absolute'
    up.style.cursor = 'pointer'
    up.style.width = this.iconSize
    up.style.height = this.iconSize
    up.style.left = state.x + state.width / 2 - 10 * this.scale + 'px'
    up.style.top = state.y - 28 * this.scale + 'px'

    state.view.graph.container.appendChild(up)
    this.images.push(up)
    mx.mxEvent.addGestureListeners(up, (evt: any) => {
      if (this.handle) {
        this.handle('up', evt, state)
      }
    })
  }
  createDownIcon(state: mxCellState) {
    const down = mx.mxUtils.createImage('images/triangle-down.png')
    down.setAttribute('title', '平级节点')
    down.style.position = 'absolute'
    down.style.cursor = 'pointer'
    down.style.width = this.iconSize
    down.style.height = this.iconSize
    down.style.left = state.x + state.width / 2 - 10 * this.scale + 'px'
    down.style.top = state.y + (state.height + 6 * this.scale) + 'px'

    state.view.graph.container.appendChild(down)
    this.images.push(down)
    mx.mxEvent.addGestureListeners(down, (evt: any) => {
      if (this.handle) {
        this.handle('down', evt, state)
      }
    })
  }
}

// function iconSet(state: mxCellState) {
//   if (state.cell.collapsed) return
//   this.images = []

//   var graph = state.view.graph
//   const scale = graph.view.scale
//   const iconSize = `${22 * scale}px`
//   // Icon1
//   let level = true
//   if (state.cell.edges && state.cell.edges.length > 0) {
//     state.cell.edges.forEach((ele) => {
//       if (ele.target.id === state.cell.id) {
//         if (!ele.source.$edit) {
//           level = false
//         }
//       }
//     })
//   }
//   if (level) {
//     var right = mx.mxUtils.createImage('triangle-right.png')
//     right.setAttribute('title', '平级节点')
//     right.style.position = 'absolute'
//     right.style.cursor = 'pointer'
//     right.style.width = iconSize
//     right.style.height = iconSize
//     right.style.left = state.x + (state.width + 6 * scale) + 'px'
//     right.style.top = state.y + state.height / 2 - 10 * scale + 'px'

//     mx.mxEvent.addGestureListeners(
//       right,
//       mx.mxUtils.bind(this, function (evt) {
//         const cloneCell = graph.model.cloneCell(state.cell)
//         let x = cloneCell.geometry.x
//         let y = cloneCell.geometry.y

//         const relation = vue.relations.find(
//           (ele) => ele.endId === cloneCell.nodeId
//         )
//         let id = null
//         if (relation) {
//           id = relation.startId
//         }
//         vue.dropSuccessCb(graph, null, null, x + 250, y, id)
//       })
//     )

//     state.view.graph.container.appendChild(right)
//     this.images.push(right)
//     // left
//     var left = mx.mxUtils.createImage('triangle-left.png')
//     left.setAttribute('title', '平级节点')
//     left.style.position = 'absolute'
//     left.style.cursor = 'pointer'
//     left.style.width = iconSize
//     left.style.height = iconSize
//     left.style.left = state.x - 28 * scale + 'px'
//     left.style.top = state.y + state.height / 2 - 10 * scale + 'px'

//     mx.mxEvent.addGestureListeners(
//       left,
//       mx.mxUtils.bind(this, function (evt) {
//         const cloneCell = graph.model.cloneCell(state.cell)
//         let x = cloneCell.geometry.x
//         let y = cloneCell.geometry.y
//         const relation = vue.relations.find(
//           (ele) => ele.endId === cloneCell.nodeId
//         )
//         let id = null
//         if (relation) {
//           id = relation.startId
//         }
//         vue.dropSuccessCb(graph, null, null, x - 250, y, id)
//       })
//     )

//     state.view.graph.container.appendChild(left)
//     this.images.push(left)
//   }

//   // bottom
//   var bottom = mx.mxUtils.createImage('triangle-down.png')
//   bottom.setAttribute('title', '下层节点')
//   bottom.style.position = 'absolute'
//   bottom.style.cursor = 'pointer'
//   bottom.style.width = iconSize
//   bottom.style.height = iconSize
//   bottom.style.padding = '0px'

//   bottom.style.left = state.x + state.width / 2 - 12 * scale + 'px'
//   bottom.style.top = state.y + (state.height + 8 * scale) + 'px'

//   mx.mxEvent.addGestureListeners(
//     bottom,
//     mx.mxUtils.bind(this, function (evt) {
//       // Disables dragging the image
//       mx.mxEvent.consume(evt)
//     })
//   )

//   mx.mxEvent.addListener(
//     bottom,
//     'click',
//     mx.mxUtils.bind(this, function (evt) {
//       const cloneCell = graph.model.cloneCell(state.cell)
//       let x = cloneCell.geometry.x
//       let y = cloneCell.geometry.y
//       let id = cloneCell.nodeId
//       vue.dropSuccessCb(graph, null, null, x, y + 250, id)
//     })
//   )

//   state.view.graph.container.appendChild(bottom)
//   this.images.push(bottom)
// }

// iconSet.prototype.destroy = function () {
//   if (this.images != null) {
//     for (var i = 0; i < this.images.length; i++) {
//       var img = this.images[i]
//       img.parentNode.removeChild(img)
//     }
//   }

//   this.images = null
// }
export default mxIcon
